import showdown from 'showdown';

export function initialize() {
  // Strip the 1-2 space padding legal docs use to right-align list numbers
  // (" 1." ... " 9." then "10."). With disableForced4SpacesIndentedSublists,
  // Showdown reads that padding as nesting and spawns a spurious sublist at the
  // 9->10 boundary. Trade-off: genuine 1-2 space nesting is flattened too; real
  // nesting needs 3+ spaces. Mirrors envoy-web's normalize_right_aligned_lists.
  showdown.extension('legalDocumentMarkdown', function () {
    return [
      {
        type: 'lang',
        filter(text) {
          let inCodeFence = false;

          return text
            .split('\n')
            .map((line) => {
              const trimmed = line.replace(/^\s+/, '');
              if (trimmed.startsWith('```') || trimmed.startsWith('~~~')) {
                inCodeFence = !inCodeFence;
              }
              if (inCodeFence) return line;

              return line.replace(/^ {1,2}(?=\d+\.\s)/, '');
            })
            .join('\n');
        },
      },
    ];
  });

  showdown.extension('summaryPageMessageMarkdown', function () {
    return [
      {
        type: 'html',
        regex: '<h1 id="(.*)">',
        replace: '<h1 class="text-4xl">',
      },
      {
        type: 'html',
        regex: '<h2 id="(.*)">',
        replace: '<h2 class="text-3xl">',
      },
      {
        type: 'html',
        regex: '<h3 id="(.*)">',
        replace: '<h3 class="text-2xl">',
      },
      {
        type: 'html',
        regex: '<h4 id="(.*)">',
        replace: '<h4 class="text-xl">',
      },
      {
        type: 'html',
        regex: '<h5 id="(.*)">',
        replace: '<h5 class="text-lg">',
      },
      {
        type: 'html',
        regex: '<h6 id="(.*)">',
        replace: '<h6 class="text-base">',
      },
    ];
  });
}

export default {
  name: 'register-showdown-extensions',
  initialize,
};
